module.exports = __webpack_public_path__ + "img/staffPhoto2.7e826661.png";